import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackVirtualPageView } from '../helpers/analytics';
import { trackHomepageEngagementEvent } from '../helpers/homepageEngagement';

const getRouteName = (pathname: string) => {
  if (pathname === '/') return 'home';
  if (pathname === '/trades') return 'trades';
  if (pathname === '/quick-setup') return 'quick_setup';
  if (pathname === '/get-started') return 'business_setup';
  if (pathname === '/sign-in') return 'sign_in';
  if (pathname === '/portal') return 'portal';
  if (pathname.startsWith('/admin')) return 'admin';
  if (pathname.startsWith('/billing')) return 'billing';
  if (pathname.startsWith('/business')) return 'business';
  if (pathname.startsWith('/manage-services')) return 'services';
  if (
    pathname === '/terms' ||
    pathname === '/privacy' ||
    pathname === '/cookies' ||
    pathname === '/data-processing-agreement' ||
    pathname === '/acceptable-use' ||
    pathname === '/subprocessors'
  ) {
    return 'legal';
  }

  return 'unknown';
};

const AnalyticsRouteTracker = () => {
  const location = useLocation();
  const previousPathRef = useRef<string | null>(null);

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}${location.hash}`;
    const previousPath = previousPathRef.current;
    const state = location.state as { homepageSignupSource?: string } | null;

    trackVirtualPageView({
      pagePath,
      pageTitle: typeof document === 'undefined' ? '' : document.title,
      route: getRouteName(location.pathname),
    });

    if (previousPath === '/' && location.pathname === '/quick-setup') {
      trackHomepageEngagementEvent('homepage_signup_page_opened', {
        source: state?.homepageSignupSource ?? 'home',
        destination: pagePath,
        metadata: {
          previousPath,
        },
      });
    }

    previousPathRef.current = location.pathname;
  }, [location.hash, location.pathname, location.search, location.state]);

  return null;
};

export default AnalyticsRouteTracker;
